// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Permission Elevation API
 * API for engineers to elevate and de-elevate their permissions within Aura.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnumAccessType } from './EnumAccessType';
import {
  EnumAccessTypeFromJSON,
  EnumAccessTypeFromJSONTyped,
  EnumAccessTypeToJSON,
  EnumAccessTypeToJSONTyped,
} from './EnumAccessType';

/**
 *
 * @export
 * @interface RequestElevatePermissionsRequest
 */
export interface RequestElevatePermissionsRequest {
  /**
   * Type of access to elevate
   * @type {EnumAccessType}
   * @memberof RequestElevatePermissionsRequest
   */
  accessType?: EnumAccessType;
  /**
   * Reason for the elevation, used for review
   * @type {string}
   * @memberof RequestElevatePermissionsRequest
   */
  justification?: string;
  /**
   * Team the elevation is for; metadata only, never an authorisation input
   * @type {string}
   * @memberof RequestElevatePermissionsRequest
   */
  team?: string;
}

/**
 * Check if a given object implements the RequestElevatePermissionsRequest interface.
 */
export function instanceOfRequestElevatePermissionsRequest(
  value: object,
): value is RequestElevatePermissionsRequest {
  return true;
}

export function RequestElevatePermissionsRequestFromJSON(
  json: any,
): RequestElevatePermissionsRequest {
  return RequestElevatePermissionsRequestFromJSONTyped(json, false);
}

export function RequestElevatePermissionsRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RequestElevatePermissionsRequest {
  if (json == null) {
    return json;
  }
  return {
    accessType:
      json['access_type'] == null
        ? undefined
        : EnumAccessTypeFromJSON(json['access_type']),
    justification:
      json['justification'] == null ? undefined : json['justification'],
    team: json['team'] == null ? undefined : json['team'],
  };
}

export function RequestElevatePermissionsRequestToJSON(
  json: any,
): RequestElevatePermissionsRequest {
  return RequestElevatePermissionsRequestToJSONTyped(json, false);
}

export function RequestElevatePermissionsRequestToJSONTyped(
  value?: RequestElevatePermissionsRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    access_type: EnumAccessTypeToJSON(value['accessType']),
    justification: value['justification'],
    team: value['team'],
  };
}
